import { render, staticRenderFns } from "./InfoSection.vue?vue&type=template&id=73aeb4d4&"
import script from "./InfoSection.vue?vue&type=script&lang=js&"
export * from "./InfoSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports